export class Section {
    constructor(id, name, status, description, position, width, required, questions) {
        this.id = id;
        this.name = name;
        this.status = status;
        this.description = description;
        this.position = position;
        this.width = width;
        this.required = required;
        this.questions = questions;
    }
}
